import * as React from 'react';
import { Link } from 'react-router-dom';

import { BrandingData } from '../types';
import * as styles from './Header.module.scss';
import builtLogo from '../images/img-built-logo.svg';

/**
 * Renders the page top bar
 */
export default function Header({ branding, logout }: HeaderProps) {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <Link to="/">
          <img src={builtLogo} />
        </Link>
      </div>
    </div>
  );
}

export interface HeaderProps {
  /** Optional branding */
  branding?: BrandingData;

  /** Callback to logout */
  logout(): void;
}



// WEBPACK FOOTER //
// ./src/components/Header.tsx